import {createSlice} from '@reduxjs/toolkit';
import {httpPost} from '../../../util/Rest';
// import { GLOBAL_FIELD } from "../../../constants/MicroServiceConstants";
import {LETTER_CONSTANT} from '../../../constants/Lookup';
const initialData = {
  isLoading: false,
  errorMsg: null,
  successMsg: null,
  letterConstantData: [],
};

const slice = createSlice({
  name: 'letterSummary',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },

    getLetterConstantData: (state, action) => {
      state.letterConstantData = action.payload?.['LETTER_CONSTANT'] ?
        action.payload['LETTER_CONSTANT'] :
        [];
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.response;
    },
    fetchSuccess: (state, action) => {
      state.successMsg = action.payload.response;
      state.isLoading = false;
    },
    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.data?.error ? action.payload.data.error : action.payload;
      state.isLoading = false;
    },
  },
});

export default slice.reducer;

const {fetchStart, fetchError, getLetterConstantData} = slice.actions;

export const getLetterConstant = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    Promise.all([
      httpPost('lookup/find/all/lookup', {
        typeCode: [LETTER_CONSTANT],
      }),
    ])
      .then((data) => {
        if (data && data[0].status && data[0].status === 200) {
          dispatch(getLetterConstantData(data[0]?.data));
        } else {
          dispatch(fetchError(data?.message));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};
